// src/App.tsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
// import About from './pages/About';
import Archive from './pages/Archive';
import Contact from './pages/Contact';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Story from './pages/Story';
import Research from './pages/Research';

const App: React.FC = () => {
  return (
    <Router>
      <div>
      <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/research" element={<Research />} />
          <Route path="/archive" element={<Archive />} />
          <Route path="/research" element={<Research />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/archive/:slug" element={<Story />} />
        </Routes>
        <div className="mt-12"> {/* Added mt-12 for spacing and mb-16 for bottom margin */}
          <Footer />
        </div>

      </div>
    </Router>
  );
};

export default App;
